module.exports = __webpack_public_path__ + "static/media/sc_14_i.3a36726b.png";